/* eslint-disable no-empty-function */
import $ from 'jquery';
import page from '../../../smartpak/page'; 

const reviews = {
    updateBVData: function() {
        var $numReviews = $('.reviewStars .bv_numReviews_component_container'),
            $numberOfReviews = $numReviews.find('meta[itemprop="reviewCount"]'),
            numberOfReviews = $numberOfReviews.length ? $numberOfReviews.attr('content') : 0,
            hasStars = numberOfReviews > 0;

        this._getReviewStars($numReviews, hasStars);
        this._getReviewSummary(hasStars, numberOfReviews);
        this._bindEvents();
    },
    _bindEvents: function() {
        $('.reviewStars')
            .removeClass('jsHide')
            .addClass('inline');

            
        $('#writeReviewCTA').on('click', '#reviewCTAButton', this._handleWriteReviewsClick.bind(this));
    },
    _getReviewSummary: function(hasStars, reviewNum) {
        var avgStars = $('.reviewStars .bv_avgRating_component_container').text(),
            formattedAvg = parseFloat(avgStars.split('out')[0]).toFixed(1),
            num = this._formatAvgStars(formattedAvg),
            starNum = num.replace(/\./gi, '_'),
            imgPath = this._displayStarsImage(starNum, hasStars),
            reviewStr = parseInt(reviewNum) === 1 ? ' Review' : ' Reviews';

        $('#starAvg').html((isNaN(num) ? '0' : num) + ' out of 5');
        $('#reviewsOverviewStars').attr({
            src: imgPath,
            alt: ''
        });
        $('#reviewTotal').html(reviewNum + reviewStr);
    },
    _formatAvgStars: function(stars) {
        var starsContent = stars.replace(/\.0/gi, '');

        return starsContent;
    },
    _displayStarsImage: function(num, hasStars) {
        var path = '/images/productClass/bigStars/',
            starPath = path + $.trim(num) + '.svg',
            noStarPath = path + '0.svg';

        return hasStars ? starPath : noStarPath;
    },
    _getReviewStars: function($container, hasStars) {
        var $reviews = $container.find('.bv_numReviews_text'),
            numberOfReviews = parseInt($reviews.text().replace(/\(|\)/gi, '')),
            content = numberOfReviews > 1 ? numberOfReviews : numberOfReviews;

            if (hasStars) {
                $reviews.html('(' + content + ')');
            } else {
                $reviews.html('write a review');
            }
    },
    _setRecommendPercent: function() {
        var initial = $('.bv-percent-recommend-container')
                .html()
                .split('('),
            percent = initial[1].split(')')[0],
            $recommended = $('#dRecommendedCount, #recommendPercentLine');

        if (this._isPercentageViewable(percent)) {
            $('.percentRecommend').html(percent);
            $recommended.removeClass('jsHide').addClass('inline');
        }
    },
    _isPercentageViewable: function(percent) {
        var percentageThreshold = 85,
            numPercent = parseInt(percent.replace(/%/gi, ''));

        return numPercent > percentageThreshold;
    },
    _formatWithCommas: function(num) {
        return (!num ? 0 : num).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    _addCountToElement: function($element, countVar) {
        if ($element.length < 1) {
            return;
        }

        var elementText = $element.text(),
            countString = this._formatWithCommas(countVar),
            countElement = "<span class='count'>(" + countString + ')</div>';

        if (countVar < 1) {
            return;
        }
        if (/\(/gi.test(elementText)) {
            return;
        }
        $element.html(elementText + countElement);
    },
    _handleWriteReviewsClick: function() {
        var $clicker = $('#writeReviewClicker'),
            $firstReviewButton = $('.bv-write-review-label'),
            $clickerElement = $(
                '<button id="writeReviewClicker" class="bv-write-review bv-focusable bv-submission-button" style="display:none !important;"> </button>'
            );

        if ($firstReviewButton.length) {
            $clicker = $('#writeReviewClicker');

            $clickerElement.appendTo('#reviewsTab .bv-content-placeholder');
            $clicker.removeClass();
            $clicker.addClass(
                'bv-write-review-label bv-text-link bv-focusable bv-submission-button bv-fake-visited jsHide'
            );
        }

        if ($clicker.length < 1 && $firstReviewButton.length < 1) {
            $clickerElement.appendTo('#reviewsTab .bv-write-review-container');
        }

        $('#writeReviewClicker').trigger('click');
    },
    _displayQACount: function(totalQuestionCount) {
        $('.sectionLabel#QA').append("&nbsp;<span id='qaTotalCount' />");

        if (page.isMobile()) {
            this._addCountToElement($('#qaTotalCount'), totalQuestionCount);
        }
    },
    _getQACount: function() {
        var productClassId = window.productClassData.id,
            bvQaApiUrl =
                window.smartPak.pageData.conversationsQuestionsApiUrl.replace(/&amp;/g, '&') +
                productClassId +
                '&Limit=100';

        crossDomainAjax(
            bvQaApiUrl,
            function(data) {
                this._displayQACount(data.TotalResults);
            }.bind(this)
        );
    }
};

function executeXDomainRequest(url, successCallback) {
    var xdr = new window.XDomainRequest();

    xdr.onload = function() {
        var dom = new window.ActiveXObject('Microsoft.XMLDOM'),
            responseJson = $.parseJSON(xdr.responseText);

        dom.async = false;
        successCallback(responseJson);
    };

    xdr.onprogress = function() {};

    xdr.onerror = function() {
        window._result = false;
    };

    xdr.open('get', url);
    xdr.send();
}

function crossDomainAjax(url, successCallback) {
    var dfd = new $.Deferred(),
        success = $.isFunction(successCallback) ? successCallback : function() {};

    $.ajax({
        url: url,
        cache: true,
        dataType: 'json',
        type: 'GET',
        async: true,
        success: function(data) {
            success(data);
            dfd.resolve(data);
        },
        error: function() {
            if (typeof window.XDomainRequest !== 'undefined') {
                executeXDomainRequest(url, function(data) {
                    success(data);
                    dfd.resolve(data);
                });
            } else if (success) {
                success(null);
            }
        }
    });

    return dfd.promise();
}

export default reviews;